import styled from 'styled-components'
import { Theme } from 'styles/Themes'
import whiteFlag from './whiteFlag.png'

interface IStyleProps {
  img?: string
  opacity?: number
  color?: any
  center?: boolean
  start?: boolean
  regular?: boolean
  shadow?: boolean
  isEvenly?: boolean
}

export const Container = styled.div`
  width: ${(props: IStyleProps) => {
    if (props.shadow) return '268px'
    return '260px'
  }};
  height: ${(props: IStyleProps) => {
    if (props.shadow) return '340px'
    return '335px'
  }};
  padding: ${(props: IStyleProps) => {
    if (props.shadow) return '0 0 5px 5px'
    return '0'
  }};
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
`

export const Card = styled.div`
  width: 260px;
  height: 330px;
  position: absolute;
  bottom: ${(props: IStyleProps) => {
    if (props.shadow) return '5px'
    return '0'
  }};
  left: ${(props: IStyleProps) => {
    if (props.shadow) return '5px'
    return '0'
  }};
  z-index: 1;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background: ${Theme.pallete.SECONDARY};
  box-shadow: ${(props: IStyleProps) => {
    if (props.shadow) return '0px 2px 8px 0px rgba(0, 0, 0, 0.25)'
    return ''
  }};
`

export const CardContainer = styled.div`
  width: 100%;
  height: 224.34px;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: ${(props: IStyleProps) => {
    if (props.isEvenly) return 'space-evenly'
    return 'space-between'
  }};
  padding: 20px 0 10px 0;
`

export const ImageContainer = styled.div`
  background-image: ${(props: IStyleProps) => `url(${props.img})`};
  background-color: ${Theme.pallete.QUATERNARY};
  background-repeat: no-repeat;
  background-size: cover;
  width: 260px;
  height: 99.54px;
  z-index: 1;
  position: relative;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none; /* Garante que o gradiente não interfira com interações do usuário */
  }
`

export const ImageContentStyle = styled.div`
  width: 260px;
  height: 99.54px;
  position: absolute;
  z-index: 3;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 9px;
`

export const Gradient = styled.div`
  width: 260px;
  height: 99.54px;
  position: absolute;
  z-index: 2;
  background-color: ${(props: IStyleProps) => {
    if (props.opacity) return `#000000${Number(props.opacity)}`
    return '#00000090'
  }};
  top: 0;
`

export const FlagIcon = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 4;
`

export const FlagText = styled.span`
  position: absolute;
  white-space: nowrap;
  text-overflow: ellipsis;
  top: 11.06px;
  right: -6px;
  z-index: 4;
  font-weight: 700;
  transform: rotate(45deg);
  font-size: 8px;
  text-align: center;
  width: 55px;
  color: ${(props: IStyleProps) => {
    if (props.color) return props.color
    return Theme.pallete.PRIMARY
  }};
`

export const MinRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props: IStyleProps) => {
    if (props.center) return 'center'
    if (props.start) return 'flex-start'
    return 'space-between'
  }};
  align-items: center;
  width: 100%;

  .svg-card-icon {
    position: relative;
    z-index: 3;
    width: 20px;
    height: 20px;
    filter: grayscale();
  }
`

export const Tags = styled(MinRow)`
  flex-wrap: wrap;
  position: relative;
  z-index: 3;
  gap: 6px;
`

export const ColoredTag = styled.div`
  background-color: ${(props) => {
    if (props.color?.toLowerCase() === '##DF7A58') return 'white'
    if (props.color?.toLowerCase() === '#0f0f0f') return 'white'
    if (props.color) return props.color
    return `white`
  }};
  padding: 2.37px 6px;
  border-radius: 100px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const TagText = styled.span`
  font-size: 10px;
  font-weight: ${(props: IStyleProps) => {
    if (props.regular) return '400'
    return '700'
  }};
  color: ${(props) => {
    if (props.color?.toLowerCase() === '##DF7A58') return 'black'
    if (props.color?.toLowerCase() === '#0f0f0f') return 'white'
    if (props.color) return props.color
    return `white`
  }};
`

export const InvestTitle = styled.span`
  color: ${Theme.pallete.SECONDARY};
  font-weight: 700;
  position: relative;
  z-index: 3;
  line-height: 20px;
  font-size: 14px;
  margin: 0 0 0 6.32px;
`

export const InvestText = styled.span`
  font-size: 12px;
  font-weight: 300;
  color: ${Theme.pallete.PRIMARY};
`

export const MoneyText = styled.span`
  font-weight: 700;
  font-size: 12px;
  margin-left: 12px;
  color: ${Theme.pallete.PRIMARY3};
`

export const RateColoured = styled.span`
  color: ${(props) => {
    if (props.color) return props.color
    return `${Theme.pallete.PRIMARY}`
  }};
  color: ${(props) => props.theme.colors.primary};
  font-weight: 700;

  font-size: 14px;
`

export const RateText = styled.span`
  color: ${Theme.pallete.PRIMARY};
  font-weight: 300;
  font-size: 10px;
`

export const Link = styled.a`
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
  border-radius: 15px;
  padding: 3px 8px;
  color: ${(props) => {
    if (props.color === '#0f0f0f') return `${Theme.pallete.SECONDARY}`
    return `${Theme.pallete.PRIMARY}`
  }};
  background-color: ${(props) => {
    if (props.color) return props.color
    return `${Theme.pallete.PRIMARY}`
  }};
  display: flex;
  align-items: center;
  margin-top: 15px;

  .link-elo-icon {
    height: 8px;
    width: 8px;
    margin-left: 10px;
    filter: ${(props) => {
      if (props.color === '#0f0f0f')
        return 'invert(100%) sepia(1%) saturate(0%) hue-rotate(265deg) brightness(104%) contrast(104%)'
      return 'none'
    }};
  }
`
export const Trash = styled.img`
  position: absolute;
  top: 30px;
  right: 40px;
  height: 18px;
  width: 18px;
  z-index: 999;
  cursor: pointer;
`
export const GuaranteeFlag = styled.div`
  position: absolute;
  top: -5px;
  right: -4px;
  background-image: url(${whiteFlag});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 67px;
  height: 67px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`

export const GuaranteeText = styled.span`
  font-family: 'Roboto';
  font-weight: 700;
  font-size: 8px;
  line-height: 12px;
  letter-spacing: 0px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 15px;
  color: ${({ theme }) => theme.colors.primary};
  position: absolute;
  transform: rotate(45deg);
  top: 15px;
  right: -3px;
`
